import { BoxProps, ColorOptions, convertHexToRGBA, ImageProps, TextProps } from '@jfs/ui-new'
import { Colors } from '../../../util/util'

const defaultStyles = {
  topContainerStyle: {
    alignContent: 'center',
    justifyContent: 'center',
  } as BoxProps,
  topTextStyle: {
    fontSize: 'FONT_SIZE_LARGE_PLUS',
    fontWeight: '500',
    textAlign: 'center',
    color: 'BLACK_75',
    marginVertical: 8,
    marginHorizontal: 24,
  } as TextProps,
  containerLogo: {
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    height: 120,
    width: 120,
    borderRadius: 120 / 2,
    overflow: 'hidden',
    borderWidth: 0.1,
    borderColor: 'LIGHTEST_GREY',
    backgroundColor: convertHexToRGBA(Colors.SECONDARY, 8) as ColorOptions,
  } as BoxProps,
  logo: {
    height: 120,
    width: 120,
  } as ImageProps,
  placeHolderText: {
    color: 'WHITE',
    fontWeight: 'FONT_WEIGHT_LIGHT',
    fontSize: 30,
  } as TextProps,
  placeHolderContainer: {
    height: '100%',
    width: '100%',
    backgroundColor: 'PRIMARY',
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  iconSize: 72,
}

const logoTypes = {
  huge: {
    ...defaultStyles,
  },
  small: {
    ...defaultStyles,
    containerLogo: {
      alignSelf: 'center',
      height: 24,
      width: 24,
      borderColor: 'GREY_SEPARATOR',
      backgroundColor: 'WHITE',
      borderWidth: 1,
      borderRadius: 24 / 2,
      overflow: 'hidden',
    } as BoxProps,
    logo: {
      height: 24,
      width: 24,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 10,
    } as TextProps,
  },
  medium: {
    ...defaultStyles,
    containerLogo: {
      alignSelf: 'center',
      height: 38,
      width: 38,
      borderRadius: 38 / 2,
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: convertHexToRGBA(Colors.SECONDARY, 8) as ColorOptions,
    } as BoxProps,
    logo: {
      height: 38,
      width: 38,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 13,
    } as TextProps,
    iconSize: 32,
  },
  large: {
    ...defaultStyles,
    containerLogo: {
      ...defaultStyles.containerLogo,
      height: 54,
      width: 54,
      borderRadius: 54 / 2,
    } as BoxProps,
    logo: {
      height: 54,
      width: 54,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 20,
    } as TextProps,
    iconSize: 32,
  },
}

export { logoTypes }
